import Vue from "vue";
import {
  zLanguageChanger,
  zPayPinForm,
  zPayLoginClientForm,
  zCameraModal,
  zValidationGuestModal
} from "zoox-components";
import { ApiClient } from "zoox-infra";
import sessionMixin from "@/components/shared/mixins/sessionMixin";
import { socketMixin } from "smck-service";
import ChargesPreCheckinGrid from "@/components/shared/ChargesPreCheckinGrid";
import ReservationDataHeader from "@/components/shared/ReservationDataHeader";
import { CompanyService, ReservationService } from "smck-service";
import PaymentService from "@/service/payment-service";
import PersonService from "@/service/person-service";
import CardService from "@/service/card-service";
import PayRecognizedPerson from "@/components/shared/PayRecognizedPerson";
import PayChargePaid from "@/components/shared/PayChargePaid";
import PaymentMethods from "@/components/shared/PaymentMethods";
import CreditCard from "@/components/shared/CreditCard";
import CreateCustomerDialog from "@/components/shared/CreateCustomerDialog";
import ValidateRegistrationDialog from "@/components/shared/ValidateRegistrationDialog";
import ForgotPasswordDialog from "@/components/shared/ForgotPasswordDialog";
import NewPasswordDialog from "@/components/shared/NewPasswordDialog";
import zPayActionCard from "../zPayActionCard";
import zPayLoginCard from "../zPayLoginCard";
import zPayRegisterClient from "@/components/shared/RegisterClient";
import { FlashMessageService, CustomHeadersService } from "zoox-infra";
import EntryOptions from "../EntryOptions/EntryOptions.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Payment",
  mixins: [socketMixin, sessionMixin],
  props: {
    fieldSettingsData: {
      type: Object
    },
    enableRecognition: {
      type: Boolean
    },
    enableZooxpay: {
      type: Boolean
    },
    reservation: {
      type: Object
    },
    companyName: {
      type: String
    },
    chargeToPayAtCheckin: {
      type: Object,
      default: null
    }
  },
  components: {
    ReservationDataHeader,
    EntryOptions,
    CreditCard,
    ChargesPreCheckinGrid: ChargesPreCheckinGrid,
    "z-language-changer": zLanguageChanger,
    "z-pay-pin-form": zPayPinForm,
    "z-validation-guest-modal": zValidationGuestModal,
    zPayLoginClientForm,
    zCameraModal,
    PayRecognizedPerson,
    PayChargePaid,
    PaymentMethods,
    CreateCustomerDialog,
    ForgotPasswordDialog,
    NewPasswordDialog,
    ValidateRegistrationDialog,
    zPayActionCard,
    zPayLoginCard,
    zPayRegisterClient
  },
  data() {
    return {
      pushNotificationDialog: false,
      reconOpen: false,
      enableRecon: true,
      cardService: null,
      apiClient: new ApiClient(Vue),
      paymentService: new PaymentService(),
      companyService: new CompanyService(Vue),
      reservationService: new ReservationService(),
      personService: new PersonService(),
      jsonData: [],
      total: 0,
      personId: null,
      personName: "",
      chargeToPayAtCheckinWatched: null,
      person: {
        name: "",
        documentTypeId: "",
        documentNumber: "",
        password: "",
        mobileCountryCode: "",
        mobileCityCode: "",
        mobilePhoneNumber: "",
        mobilePhoneMask: "",
        mobilePhoneCountryCode: "",
        phoneNumber: "",
        email: "",
        companyId: ""
      },
      openFaceRecognitionModalForUserRegistered: false,
      loginData: {
        documentTypeId: 1,
        documentNumber: "",
        password: ""
      },
      isIncorrectPassword: false,
      personHasLoggedIn: false,
      showAuthSuccess: false,
      showPaySuccess: false,
      chargeId: null,
      orderId: null,
      companyParams: null,
      showCreateCustomerDialog: false,
      showForgotPasswordDialog: false,
      showNewPasswordDialog: false,
      showValidateRegistrationDialog: false,
      loadingPayButton: false,
      mustFinalize: true,
      companyId: null,
      requiredWarrantyRegistrationPayment: true,
      isPaid: false,
      statusPayment: "",
      triesCount: 0,
      nothingToPay: false,
      returnedBySocket: false,
      updatedGuest: false,
      alreadyAuthenticated: false,
      paySubStep: 1,
      openCamera: false,
      radioGroupSelectValidationModel: null,
      radioGroupSelectValidationLabels: [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ],
      guestComunicationOptions: null,
      validationModalStep: 0,
      validationCode: null,
      showValidationModal: false,
      selectedGuest: null,
      lastReservations: null,
      pinNumber: null,
      successRegisteValue: null,
      iterationOptions: null,
      companyAcquirer: null
    };
  },
  async created() {
    this.$setPayStep(0);
    this.personId = this.currentGuest.personId;
    if (this.personId) {
      this.alreadyAuthenticated = true;
      await this.getTokenCharge();
    }

    if (CustomHeadersService.getCustomHeaders().Authorization) {
      let data = {
        id: this.personId,
        name: this.currentGuest.name,
        token: CustomHeadersService.getCustomHeaders().Authorization
      };
      this.personService.setLoginData(data);
    }

    if (
      this.chargeToPayAtCheckin &&
      this.chargeToPayAtCheckin.order &&
      this.chargeToPayAtCheckin.order.id &&
      this.chargeToPayAtCheckin.status === "pending"
    ) {
      if (this.reservation && this.reservation.guests) {
        const currentGuest = this.reservation.guests.find(
          g => g.id === this.$route.params.guestId
        );
        const lastIndexMobileCityCode = this.getLastIndexDdd(
          currentGuest.mobilePhoneMask
        );
        this.person.name = `${currentGuest.name} ${currentGuest.lastName}`;
        this.person.email = currentGuest.email;
        this.person.documentTypeId = currentGuest.documentTypeId;
        this.person.documentNumber = currentGuest.documentNumber;
        this.person.mobileCountryCode = currentGuest.mobileCountryCode;
        this.person.mobileCountryCode = currentGuest.mobileCountryCode;
        this.person.mobileCityCode = currentGuest.mobileCityCode;
        this.person.mobilePhoneMask = currentGuest.mobilePhoneMask;
        this.person.mobilePhoneCountryCode =
          currentGuest.mobilePhoneCountryCode;
        if (
          currentGuest.mobileCityCode &&
          currentGuest.mobilePhoneNumber &&
          currentGuest.mobilePhoneNumber.substring(
            0,
            lastIndexMobileCityCode
          ) === currentGuest.mobileCityCode
        ) {
          this.person.mobilePhoneNumber = currentGuest.mobilePhoneNumber;
        } else {
          this.person.mobilePhoneNumber =
            currentGuest.mobileCityCode + currentGuest.mobilePhoneNumber;
        }
      }
      this.chargeToPayAtCheckinWatched = this.chargeToPayAtCheckin;

      // this.chargeToPayAtCheckinWatched.token = chargesPending[0].token;
      this.chargeId = this.chargeToPayAtCheckin.id;
      this.orderId = this.chargeToPayAtCheckin.order.id;

      if (this.isPaid) {
        this.isPaid = false;
        this.$setPayStep(0);
      }

      const items = [
        {
          description: this.$t("PAYMENT.WARRANTY_REGISTRATION"),
          amount: this.chargeToPayAtCheckin.amount
        }
      ];
      const amountsInHundredths = items.map(item => item.amount * 100);
      const totalAmountInHundredths = amountsInHundredths.reduce(
        (acc, cur) => acc + cur
      );
      this.total = totalAmountInHundredths / 100;
      this.jsonData = items;
      this.cardService = new CardService();
    } else {
      this.nothingToPay = true;
    }
    $(document).ready(function() {
      $(this).scrollTop(0);
    });

    const $context = this;
    $context.$socketEmit("centralpay-back:join-reservation", {
      companyId: this.companyId,
      reservationNumber: this.reservation.reservationNumber
    });

    $context.$socketOn("centralpay-portal:update-payment", resp => {
      this.notifyPaymentStatus(resp);
    });
  },
  async mounted() {
    document.getElementById("sectionPayment").scrollIntoView();
    if (!this.nothingToPay) {
      const company = this.companyService.getLocalCompany();
      this.companyId = company.id;
      if (
        company &&
        company.parameters_sc &&
        !company.parameters_sc.operation_flow
          .requiredWarrantyRegistrationPayment
      ) {
        this.requiredWarrantyRegistrationPayment = false;
      }
      this.companyParams = await this.companyService.getFnrhFormSettings(
        company.id
      );

      this.person.companyId = company.id;
      Vue.$globalEvent.$on("onReconSuccess", data => {
        this.capture(data.image);
      });
    }
  },
  destroyed() {
    this.$socketRemove("centralpay-portal:update-payment");
  },
  methods: {
    ...mapActions(["$setCurrentPersonId", "$setIsQualifiedGuest"]),
    closeModalRecognition() {
      this.reconOpen = false;
      this.openCamera = false;
      this.openFaceRecognitionModalForUserRegistered = false;
    },
    async successRegister(value) {
      this.successRegisteValue = { ...value.success };
      this.$setPayStep(2);
      // const resp = await this.personService.login(this.successRegisteValue);
      // if (resp && resp.statusCode === 200 && resp.id) {
      //   this.personId = resp.id;
      //   this.personName = resp.name;
      //   this.currentGuest.personId = this.personId;
      //
      //   let contactList = await this.personService.getContactsList({
      //     id: this.personId,
      //     name: this.personName
      //   });
      //   this.documentLoginSuccess(contactList);
      // } else {
      //   FlashMessageService.warning(this.$t("REGISTRATION.INVALIDCODE"));
      // }
    },
    async validateCode() {
      const data = { confirmationCode: this.pinNumber };
      const resp = await this.personService
        .confirmRegistration(data)
        .catch(() => {
          FlashMessageService.warning(this.$t("REGISTRATION.INVALIDCODE"));
        });
      if (resp && resp.id) {
        await this.login(this.successRegisteValue);
        // this.$setPayStep(3);
      }
    },
    closePushNotificationModal() {
      this.pushNotificationDialog = false;
    },
    async acceptReceiveMessage() {
      const ret = await this.pushNotificationService.requestPermissionNotification();
      if (ret) {
        await this.pushNotificationService.subscribe(
          this.$route.params.guestId,
          "smck-portal-payment"
        );
        this.pushNotificationDialog = false;
        // this.openSubscriptionModal();
      } else {
        this.pushNotificationDialog = false;
      }
    },
    async checkChargeManually() {
      const chargesFailed = await this.paymentService.getCharges(this.orderId, {
        status: "failed"
      });
      const chargesProcessing = await this.paymentService.getCharges(
        this.orderId,
        { status: "processing" }
      );
      const chargesAuthorized = await this.paymentService.getCharges(
        this.orderId,
        { status: "authorized" }
      );

      if (
        chargesFailed.length > 0 &&
        chargesFailed.filter(x => x.id === this.chargeId).length > 0
      ) {
        this.statusPayment = "unauthorized_".concat(this.triesCount.toString());
      } else if (
        chargesAuthorized.length > 0 &&
        chargesAuthorized.filter(x => x.id === this.chargeId).length > 0
      ) {
        this.statusPayment = "authorized";
      } else if (
        chargesProcessing.length > 0 &&
        chargesProcessing.filter(x => x.id === this.chargeId).length > 0
      ) {
        this.triesCount++;
        this.statusPayment = "processing_".concat(this.triesCount.toString());
      }
    },
    async checkChargeStatus(status) {
      if (status === "authorized") {
        this.showPaySuccess = true;
        this.loadingPayButton = false;
        Vue.$globalEvent.$emit("changePayLoadingButton", false);
        this.statusPayment = "authorized";
        this.returnedBySocket = true;
      } else {
        this.statusPayment = "unauthorized_".concat(this.triesCount.toString());
      }
    },
    async notifyPaymentStatus(data) {
      let status = data.data.charges[0].status;
      await this.checkChargeStatus(status);
    },
    async login(loginData) {
      const resp = await this.personService.login(loginData);

      if (resp && resp.id) {
        this.personId = resp.id;
        this.personName = resp.name;
        this.currentGuest.personId = this.personId;
        let contactList = await this.personService.getContactsList({
          id: this.personId,
          name: this.personName
        });
        this.documentLoginSuccess(contactList);
      }
    },
    async getCompanyAcquirerParameters() {
      this.companyAcquirer = await this.apiClient.get(
        `portal/company/getAcquirerParameters/${this.companyId}`
      );
      this.updateIterationsOptions(this.companyAcquirer);
    },

    installmentFeeText(currentInstallment, limitInstallment) {
      if (currentInstallment >= limitInstallment) {
        return ` / ${this.$t("PAYMENT_SOLICITATION.WITH_FEE")}`;
      } else {
        return ` / ${this.$t("PAYMENT_SOLICITATION.NO_FEE")}`;
      }
    },
    formatCurrency(amount) {
      if (isNaN(amount) || amount === "") {
        return "";
      } else {
        return amount.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL"
        });
      }
    },
    updateIterationsOptions(acquirer) {
      const iterationOptions = [];
      for (let i = 1; i <= acquirer.maxInstallments; i++) {
        let installmentFeeText;
        let amountWithFee;
        const limitInstallment = acquirer.installmentsFee.find(
          ({ fee }) => fee !== 0
        );
        if (limitInstallment) {
          installmentFeeText = this.installmentFeeText(
            i,
            limitInstallment.installment
          );
          amountWithFee =
            Math.round(
              (this.calcAmountWithFee(
                i,
                limitInstallment.installment,
                limitInstallment.fee,
                this.chargeToPayAtCheckin.amount
              ) *
                100) /
                i
            ) / 100;
        } else {
          installmentFeeText = ` / ${this.$t("PAYMENT_SOLICITATION.NO_FEE")}`;
          amountWithFee =
            Math.round((this.chargeToPayAtCheckin.amount * 100) / i) / 100;
        }
        const formatedAmountWithFee = this.formatCurrency(amountWithFee);
        if (
          i === 1 ||
          Math.round(this.chargeToPayAtCheckin.amount * 100) / i >=
            Math.round(acquirer.minPerInstallment * 100)
        ) {
          iterationOptions.push({
            text: `${i} x ${formatedAmountWithFee}${installmentFeeText}`,
            value: i
          });
        }
      }

      this.iterationOptions = iterationOptions;
    },

    async documentLoginSuccess(contactList) {
      this.guestComunicationOptions = contactList.contactInfoList;
      this.showValidationModal = true;
    },
    async capture(image) {
      this.reconOpen = false;
      const resp = await this.personService.facialLogin(image);
      if (resp && resp.id) {
        this.personId = resp.id;
        this.personName = resp.name;
        this.currentGuest.personId = this.personId;
        await this.onLoginSuccess();
      }
    },
    cameraError() {
      this.reconOpen = false;
    },
    openRecon() {
      this.reconOpen = true;
    },
    checkHasChargesAtCheckin(checkinOrders) {
      return (
        checkinOrders &&
        checkinOrders.data &&
        checkinOrders.data.length > 0 &&
        checkinOrders.data[0].chargesAtCheckin &&
        checkinOrders.data[0].chargesAtCheckin.length > 0
      );
    },
    async getTokenCharge() {
      const $context = this;
      $context.chargeToPayAtCheckin.token = (
        await $context.paymentService.getCharges(
          $context.chargeToPayAtCheckin.order.id,
          { status: "pending" }
        )
      )[0].token;
      return $context.chargeToPayAtCheckin.token;
    },
    async onLoginSuccess() {
      await this.getTokenCharge();
      this.alreadyAuthenticated = true;

      this.$setPayStep(3);
    },
    async onReconSuccessClose() {
      await this.paymentService.generatePin(
        this.personId,
        this.orderId,
        this.chargeId
      );
      this.showAuthSuccess = false;
      this.$setPayStep(2);
    },
    stopCamera() {
      this.openCamera = false;
    },
    async onPinSubmit(data) {
      const isValidated = await this.paymentService.validatePin(
        this.personId,
        this.orderId,
        data.pinNumber,
        this.chargeId
      );

      if (isValidated) {
        this.$setPayStep(3);
      } else {
        FlashMessageService.error(
          this.$t("PAYMENT_SOLICITATION.PIN_NOT_VALID")
        );
      }
    },
    onPinForgot(value) {
      if (value) {
        const data = {
          documentTypeId: this.documentTypeId,
          documentNumber: this.documentNumber,
          companyId: this.companyId
        };
        this.personService.resendRegistrationCode(data).then(() => {
          FlashMessageService.success(
            this.$t("PAYMENT_SOLICITATION.PIN_GENERATED")
          );
        });
      } else {
        this.paymentService.generatePin(
          this.personId,
          this.orderId,
          this.chargeId
        );
        FlashMessageService.success(
          this.$t("PAYMENT_SOLICITATION.PIN_GENERATED")
        );
      }
    },
    successCustomerDialog() {
      this.showCreateCustomerDialog = false;
      this.showValidateRegistrationDialog = true;
    },
    async goToNextStep() {
      const resp = await this.submitReservationData();
      this.$setCurrentReservation(resp);
      await this.onPayClose("pass");
    },
    async submitReservationData() {
      if (this.updatedGuest === true) {
        return this.reservation;
      }

      this.reservation.guests = this.reservation.guests.map(guest => {
        if (guest.id === this.$route.params.guestId) {
          if (this.mustFinalize) {
            guest.completed = true;
          }
        }

        return guest;
      });

      this.updatedGuest = true;

      return this.reservationService.updateGuest(
        this.reservation.id,
        this.$route.params.guestId,
        this.reservation,
        this.mustFinalize
      );
    },
    async onPaySubmit(data) {
      try {
        this.loadingPayButton = true;
        Vue.$globalEvent.$emit("changePayLoadingButton", true);
        data.chargesToPay[0].order.code = this.reservation.reservationNumber;
        const updateResp = await this.paymentService.updatePayment(
          data.orderId,
          data.chargesToPay[0].items[0].id,
          data.chargeId,
          {
            amount: data.chargesToPay[0].amount,
            category: "warranty_registration",
            code: this.currentReservation.reservationNumber,
            description: "Registro de Garantia",
            id: data.chargesToPay[0].items[0].id,
            orderId: data.orderId,
            percent: 100,
            percentLeft: 100,
            quantity: 1
          },
          data.chargesToPay[0]
        );

        updateResp.charge.token = data.chargesToPay[0].token;
        updateResp.charge.order = data.chargesToPay[0].order;
        updateResp.charge.order.code = this.reservation.reservationNumber;
        updateResp.charge.creditCard = data.chargesToPay[0].creditCard;

        await this.paymentService.pay(
          data.orderId,
          data.chargeId,
          this.personId,
          data.chargesToPay
        );

        this.showPaySuccess = true;
        this.loadingPayButton = false;
      } catch (error) {
        this.loadingPayButton = false;
        if (error.status === 400) {
          FlashMessageService.warning(
            this.$t("GLOBAL_ERROR.PAYMENT_ALREADY_MADE")
          );
          Vue.$globalEvent.$emit("tabChange", 4);
        } else {
          FlashMessageService.error(this.$t("GLOBAL.ERROR"));
        }
      }
    },
    async onPayClose(value) {
      if (value && value !== "pass") {
        const resp = await this.submitReservationData();
        this.$setCurrentReservation(resp);

        if (this.returnedBySocket === false) {
          this.showPaySuccess = true;
          this.loadingPayButton = false;
          Vue.$globalEvent.$emit("changePayLoadingButton", false);
        }
      }

      this.$setPayStep(0);
      this.$setCurrentMobileStep(4);
    },
    goToNextStepAlreadyPaid() {
      this.$setCurrentMobileStep(4);
    },
    openForgotPasswordDialog() {
      this.showForgotPasswordDialog = true;
      return false;
    },
    callNewPasswordDialog() {
      this.showForgotPasswordDialog = false;
      this.showNewPasswordDialog = true;
    },
    goBack() {
      this.$setCurrentMobileStep(2);
    },
    async next() {
      if (!this.alreadyAuthenticated) {
        this.paySubStep++;
      } else {
        this.$setPayStep(3);
      }
      // if (!this.alreadyAuthenticated) this.$setPayStep(1);
    },
    async PayDirectly(card) {
      const cardCustomer = card.customer;
      const paymentIterations = card.paymentIterations;

      delete card.paymentIterations;
      const cardToken = await this.generateCardToken(card);

      const chargesToPay = this.buildChargesToPayDirect(
        cardCustomer,
        cardToken,
        paymentIterations
      );
      await this.paymentService.payDirectly(
        this.chargeToPayAtCheckin.order.id,
        this.chargeToPayAtCheckin.id,
        null,
        chargesToPay
      );
      this.$setPayStep(3);
      this.showPaySuccess = true;
      this.loadingPayButton = false;
    },

    async generateCardToken(card) {
      delete card.customer;
      return await this.cardService.createCardToken(card);
    },
    async buildChargesToPay(cardCustomer, cardToken) {
      const newCharge = { ...this.chargeToPayAtCheckin };
      let operationType = "auth_and_capture";
      if (newCharge.metadata.type === "warranty_registration") {
        operationType = "auth_only";
      }
      newCharge.customer = {};
      newCharge.customer.documentTypeId = cardCustomer.documentTypeId;
      newCharge.customer.documentNumber = cardCustomer.documentNumber;
      newCharge.method = "creditCard";
      newCharge.creditCard = {
        card_token: cardToken.data.id,
        operation: operationType,
        installments: 1
      };

      newCharge.metadata = {
        chargeId: newCharge.id,
        origin: "at_checkin",
        type: "warranty_registration"
      };
      newCharge.customer = {
        name: this.currentGuest.name,
        email: this.currentGuest.email,
        id: this.personId
      };
      return [newCharge];
    },
    buildChargesToPayDirect(cardCustomer, cardToken) {
      const newCharge = { ...this.chargeToPayAtCheckin };
      let operationType = "auth_only";
      newCharge.customer = {};
      newCharge.customer.documentTypeId = cardCustomer.documentTypeId;
      newCharge.customer.documentNumber = cardCustomer.documentNumber;
      newCharge.customer.name = this.person.name;
      newCharge.customer.email = this.person.email;
      newCharge.companyId = this.companyId;
      newCharge.method = "creditCard";

      newCharge.creditCard = {
        cardToken: cardToken.data.id,
        operation: operationType,
        installments: 1
      };

      newCharge.paidAmount = 0;
      newCharge.createdAt = newCharge.updatedAt;
      newCharge.expiration = moment(newCharge.updatedAt)
        .add(1, "days")
        .toISOString();
      newCharge.order = {
        id: newCharge.order.id,
        code: this.reservation.reservationNumber
      };
      newCharge.metadata = {
        type: "warranty_registration",
        origin: "at_checkin"
      };
      delete newCharge.expired;

      return [newCharge];
    },
    async Pay(card) {
      const cardCustomer = card.customer;
      const cardToken = await this.generateCardToken(card);
      const chargesToPay = this.buildChargesToPay(cardCustomer, cardToken);

      await this.paymentService.pay(
        this.chargeToPayAtCheckin.order.id,
        this.chargeToPayAtCheckin.id,
        null,
        chargesToPay
      );
      this.$setPayStep(3);
      this.showPaySuccess = true;
      this.loadingPayButton = false;
    },
    tryPayAgain() {
      this.triesCount++;
      this.statusPayment = "";
      this.paymentService
        .createPayment(
          this.orderId,
          this.person.name,
          this.chargeToPayAtCheckin.order.code,
          "",
          "",
          this.chargeToPayAtCheckin.amount,
          "Request warranty registration",
          "warranty_registration",
          { type: "warranty_registration", origin: "at_checkin" }
        )
        .then(resp => {
          this.chargeToPayAtCheckinWatched = resp.body[resp.body.length - 1];
          this.chargeId = this.chargeToPayAtCheckinWatched.id;
          this.orderId = this.chargeToPayAtCheckinWatched.order.id;
        });

      this.showPaySuccess = false;
      this.isPaid = false;
    },
    goToRegister() {},
    getLastIndexDdd(mask) {
      /* eslint-disable no-useless-escape */
      mask = mask || "";
      const maskDdd = mask
        ? mask
            .replace(/[\(|\)]/g, "")
            .replace(/[-|\.|\/]/g, " ")
            .split(" ")[0]
        : "";
      if (mask.length === maskDdd.length) {
        return 0;
      }
      return maskDdd.length >= 4 ? maskDdd.length - 2 : maskDdd.length;
    },
    reconFailForUserRegistered: function() {
      this.openFaceRecognitionModalForUserRegistered = false;
    },
    reconSuccessForUserRegistered: function(resp) {
      this.openFaceRecognitionModalForUserRegistered = false;

      this.guestComunicationOptions = resp.resp.lastReservations[0].guests.filter(
        x => x.hasOwnProperty("personId")
      )[0].contactInfoList;

      this.lastReservations = resp.resp.lastReservations;
      this.selectedGuest = resp.resp.lastReservations[0].guests.find(x =>
        x.hasOwnProperty("personId")
      );
      this.$setCurrentPhoto(resp.image);
      this.showValidationModal = true;
    },
    async resendCode(value) {
      return this.sendCode(value);
    },
    async sendCode(value) {
      this.validationModalStep = 0;
      if (value) {
        return this.apiClient
          .post(`portal/send-code`, {
            contactId: value.id
          })
          .then(resp => {
            if (resp.ok) {
              this.validationModalStep = 2;
            }
          });
      }
    },
    checkValidationCode(value) {
      const $context = this;
      if (value.code && value.code.length === 5) {
        return $context.apiClient
          .post(
            `portal/verify-code`,
            {
              contactId: value.contactId,
              verificationCode: value.code
            },
            null,
            false,
            true
          )
          .then(async resp => {
            if (resp.token) {
              $context.showValidationModal = false;
              $context.alreadyAuthenticated = true;
              CustomHeadersService.setCustomHeaders({
                Authorization: resp.token
              });

              const validated = {
                personId: resp.personId,
                validated: resp.validated
              };
              $context.personId = resp.personId;
              $context.$setIsQualifiedGuest(true);
              $context.reservationService.setValidatedInfo(validated);
              $context.$setCurrentPersonId(resp.personId);
              if (!$context.chargeToPayAtCheckin.token) {
                const token = await this.getTokenCharge();
                this.paymentService.updatePersonCharge(
                  resp.personId,
                  token,
                  this.person.name,
                  this.person.mobilePhoneNumber,
                  this.person.email
                );
              }

              // await $context.paymentService.generatePin(
              //   resp.personId,
              //   $context.orderId,
              //   $context.chargeId
              // );
              $context.$setPayStep(3);
            }
          })
          .catch(error => {
            if (error.status === 401) {
              FlashMessageService.error(
                $context.$t("NOVO_FLUXO.INCORRECT_PIN")
              );
            } else {
              FlashMessageService.error(
                $context.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN")
              );
            }
          });
      }
    },
    closeValidationModal() {
      this.showValidationModal = false;
      this.guestComunicationOptions = null;
      this.validationModalStep = 0;
      this.validationCode = null;
    }
  },
  computed: {
    ...mapState(["pushNotificationService"]),
    personIsAuthenticated() {
      return this.personService.isAuthenticated();
    },
    dataFormatted: function() {
      return this.jsonData.map(item => {
        item.amount = item.amount.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL"
        });

        return item;
      });
    },
    totalFormated: function() {
      return this.total.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    Headers: function() {
      return [
        {
          text: this.$t("PAYMENT.EXPENSE_ITEMS"),
          sortable: false,
          align: "left",
          customTemplate: item => {
            return item.description;
          }
        },
        {
          text: this.$t("PAYMENT.AMOUNT"),
          sortable: false,
          align: "center",
          customTemplate: item => {
            return `<strong>${item.amount}</strong>`;
          }
        }
      ];
    },
    items: {
      get() {
        return this.jsonData;
      },
      set(value) {
        return value;
      }
    },
    firstStepBtn() {
      return [
        {
          title: this.$t("PAY_LOGIN.ALREADY_REGISTERED_BUTTON"),
          action: "Login"
        },
        {
          title: this.$t("PAY_LOGIN.WANT_SIGN_UP_BUTTON"),
          action: "Register"
        }
      ];
    },
    secondStepBtn() {
      return [
        {
          title: this.$t("PAY_LOGIN.FACIAL_RECOGNITION_BUTTON_LOGIN"),
          action: "FacialRecognition"
        },
        {
          title: this.$t("PAY_LOGIN.DOCUMENT_LOGIN_BUTTON"),
          action: "TraditionalLogin"
        }
      ];
    }
  },
  watch: {
    statusPayment(val) {
      this.statusPayment = val;
    },
    chargeToPayAtCheckin(val) {
      this.chargeToPayAtCheckinWatched = val;
    },
    reservation: {
      deep: true,
      handler: async function(value) {
        let reservation = await this.reservationService.getOne(value.id);
        let charges = [];
        if (
          this.chargeToPayAtCheckin &&
          this.chargeToPayAtCheckin.order &&
          this.chargeToPayAtCheckin.order.id
        ) {
          charges = await this.paymentService.getCharges(
            this.chargeToPayAtCheckin.order.id,
            { status: "pending" }
          );
        }
        if (reservation) {
          this.isPaid = reservation.completedSteps
            ? reservation.completedSteps.payment && charges.length === 0
            : false;
          if (this.isPaid) this.$setPayStep(3);
        }
      }
    }
  }
};
